export default __webpack_public_path__ + "static/media/mentoriaDerechos.e8923605.png";